module.exports = __webpack_public_path__ + "img/monospace.b9acfc34.svg";